import { Deal } from '../types';

export function calculateSuccessProbability(deals: Deal[]): number {
  const completedDeals = deals.filter(deal => deal.status === 'completed').length;
  const totalDeals = deals.length || 1;
  const baseRate = (completedDeals / totalDeals) * 100;
  
  // Add weighted factors
  const marketConditionFactor = 1.1; // Example: positive market conditions
  const seasonalityFactor = 0.95; // Example: current season impact
  
  return Math.round(baseRate * marketConditionFactor * seasonalityFactor);
}

export function predictDealTiming(deals: Deal[]): number {
  const completedDeals = deals.filter(deal => deal.status === 'completed');
  if (completedDeals.length === 0) return 45; // Default prediction
  
  // Calculate average time to close
  const avgDays = completedDeals.reduce((sum, deal) => {
    const start = new Date(deal.startDate);
    const end = new Date(deal.actualCloseDate || deal.expectedCloseDate);
    return sum + (end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24);
  }, 0) / completedDeals.length;
  
  return Math.round(avgDays);
}